import { ProcessingChain } from 'models/ProcessingChain';

export interface ReloadFormRequest {
  id: string;
  idType: IdType;
  tradeDate: string;
  processingChain?: ProcessingChain;
  isPrivateMode?: boolean;
  rfqId?: string;
  pricerRfqId?: string;
  tabId?: string;
  quoteId?: string;
}

export enum IdType {
  QuoteId = 'QuoteId',
  ExternalQuoteId = 'ExternalQuoteId',
  PriceId = 'PriceId',
  ProductId = 'ProductId',
  Guess = 'Guess',
}
